import React, { useEffect, useState, useContext } from "react";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import Preview from "../../../Pages/Preview/Preview";
import CoverEditor from "../../../Pages/CoverEditor/Editor";
import "./SampleCoverContentModal.scss";

function SampleItem({ resumedata, index, randomTemplate, full, job_title }) {
  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    isSample,
    setIsSample,
    coverJson,
    setCoverJson,
    isCoverJson,
    setIsCoverJson,
    isCoverSample,
    setIsCoverSample,
    jsonCoverIndex,
    setJsonCoverIndex,
  } = useContext(jsonEditorContext);
  //Json Handle

  useEffect(() => {
    let data = JSON.parse(resumedata);
    data.from.jobTitle = job_title;
    data.customization =
      randomTemplate &&
      randomTemplate.settings &&
      randomTemplate.settings.customization;
    data.editorSettings =
      randomTemplate &&
      randomTemplate.settings &&
      randomTemplate.settings.editorSettings;
    data.template_id = randomTemplate && randomTemplate.template_code;
    // setJson(data);
    // setJsonIndex(index);
    // setIsJson(true);
    setCoverJson(data);
    setJsonCoverIndex(index);
    setIsCoverJson(true);
    setIsCoverSample(true);
  }, [resumedata, index]);

  return (
    <div className="sample_img_modal  w-100">
      <div
        className="preview_scale"
        style={
          full
            ? { transform: "scale(0.85)", transformOrigin: "0px 0px" }
            : { transform: "scale(0.25)", transformOrigin: "0px 0px" }
        }
      >
        <CoverEditor index={index} sample={true} preview={true} />
      </div>
    </div>
  );
}

export default SampleItem;
